import * as React from "react";
const SvgRewindFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M19.6 6.8A2 2 0 0 1 20 8v8a2 2 0 0 1-3.2 1.6L13 14.75V16a2 2 0 0 1-3.2 1.6l-5.333-4a2 2 0 0 1 0-3.2l5.333-4A2 2 0 0 1 13 8v1.25l3.8-2.85a2 2 0 0 1 2.8.4", clipRule: "evenodd" }));
export default SvgRewindFill;
